module.exports = __webpack_public_path__ + "static/media/project-setup.978d924b.svg";